import * as Sentry from '@sentry/browser'
import { getAuth } from 'firebase/auth'
import { nanoid } from 'nanoid'
import { kUserSkillsPath } from '@/constants/constants-api-paths'
import { kErrorCodeAuthError } from '@/constants/constants-error-codes'
import { kPaxtonAppApiRESTBaseUrl } from '@/constants/constants-links'
import { getResponseDebugContext } from '@/util/api/response-body'
import { ApiError } from '@/util/errors/api-error'
import { ApiResponsePayloadError } from '@/util/errors/api-response-payload-error'

export default async function deleteUserSkill(skillId: string): Promise<void> {
  const sentryTransactionId = nanoid()
  try {
    const token = await getAuth().currentUser?.getIdToken()
    if (!token) throw new Error(kErrorCodeAuthError)

    const apiUrl = `${kPaxtonAppApiRESTBaseUrl()}${kUserSkillsPath}/${encodeURIComponent(skillId)}`
    const response = await fetch(apiUrl, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json; charset=UTF-8',
        'X-Transaction-Id': sentryTransactionId,
      },
    })
    if (!response.ok) {
      const error = new ApiError(response.status, 'The skills request failed. Please try again.')
      Sentry.withScope((scope) => {
        scope.setTags({ transaction_id: sentryTransactionId })
        Sentry.captureException(error, { extra: getResponseDebugContext(response, apiUrl) })
      })
      throw error
    }

    if (response.status !== 204) {
      const error = new ApiResponsePayloadError(response.status, 'Invalid skill deletion response')
      Sentry.captureException(error, { extra: getResponseDebugContext(response, apiUrl) })
      throw error
    }
  } catch (error) {
    if (!(error instanceof ApiError)) {
      Sentry.withScope((scope) => {
        scope.setTags({ transaction_id: sentryTransactionId })
        Sentry.captureException(error)
      })
    }
    throw error
  }
}
